import React from 'react';
import { Tooltip, Dropdown, Button, Menu, Icon } from 'antd';
import { useDispatch } from 'react-redux';
import { notificationConstants } from '../../../../constants/notification.constants';
import useToggleFilter from '../../hooks/useToggleFilter';
import { resetFilterState } from '../../store/actions';
import styles from './OpenResetFilter.module.scss';

const DropdownMenu = ({ ...props }) => {
  const dispatch = useDispatch();

  const resetFilter = () => {
    dispatch({
      type: notificationConstants.NOTIFICATION_CLEAR,
      payload: null,
    });

    dispatch(resetFilterState());
  };

  return (
    <Menu {...props} onClick={resetFilter}>
      <Menu.Item className={styles.menuItem}>
        <Icon type="sync" />
        Сбросить
      </Menu.Item>
    </Menu>
  );
};

const OpenResetFilter = () => {
  const dispatch = useDispatch();

  const toggleFilter = useToggleFilter();

  const handleFilterBtnClick = () => {
    dispatch({
      type: notificationConstants.NOTIFICATION_CLEAR,
      payload: null,
    });

    toggleFilter(true);
  };

  return (
    <Tooltip title="Фильтр" placement="left">
      <Dropdown overlay={<DropdownMenu />} placement="bottomLeft">
        <Button icon="filter" onClick={handleFilterBtnClick} />
      </Dropdown>
    </Tooltip>
  );
};

export default OpenResetFilter;
